const autocompleteModalEquipServQuest = {
  group: 'Sección'
};

export default autocompleteModalEquipServQuest;
